import {
    api_createCredit,
    api_getCreditsByUserId,
    api_getCreditRequestsCount,
    api_getCreditRequests,
    api_setInvoicePreview,
    apiGetCreditsById
} from "./credits.api";
import {
    setCredit,
    setCreditsAmount,
    setCreditsExpirationDate,
    setCreditRequests,
    reduceCreditsAmount,
    setCreditType
} from "./credits.reducers";

export const createCredit = params => dispatch => (
    dispatch(setCredit(params))
);

export const purchaseCredits = params => dispatch => (
    api_createCredit(params).then(res => {
        dispatch(setCredit(res));
        return res;
    })
);

export const getCreditRequestsCount = () => dispatch => (
    api_getCreditRequestsCount().then(res => dispatch(setCreditsAmount(res)))
);

export const getCreditRequests = (creditRequestTypes) => dispatch => (
    api_getCreditRequests(creditRequestTypes).then(res => {
        dispatch(setCreditRequests(res));
        return res;
    })
);

export const getCreditsExpirationDate = () => dispatch => (
    api_getCreditsByUserId().then(res => dispatch(setCreditsExpirationDate(res[0]?.expirationDate)))
);

export const reduceCreditsCount = () => dispatch => (
    dispatch(reduceCreditsAmount())
);

export const setInvoicePreview = body => dispatch => (
    api_setInvoicePreview(body).then(res => {
        return res;
    })
);

export const getCreditsById = (id, creditRequestTypes) => dispatch => (
    apiGetCreditsById(id, creditRequestTypes).then(res => {
        return res;
    })
);

export const updateCreditType = type => dispatch => (
    dispatch(setCreditType(type))
);
